export default __webpack_public_path__ + "static/lilnadas-cards-story-2-f757af4c437b484ab1ce3305f4ee6dea.png";